// extracted by mini-css-extract-plugin
export default {"emptyScreen":"emptyscreen_emptyScreen__su+wY"};